<template>
  <!-- start 头部 -->
  <div class="custom-bottom">
    <div class="custom-bottom-info">版本号：22.2.0.6</div>
    <div class="custom-bottom-operate">
      <img
        class="custom-bottom-operate-icon"
        src="@/assets/images/voice-icon.png"
      />
      <img
        class="custom-bottom-operate-icon"
        src="@/assets/images/music-icon.png"
      />
      <img
        class="custom-bottom-operate-icon"
        src="@/assets/images/setting-icon.png"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomBottom",
};
</script>

<style lang="scss" scoped>
.custom-bottom {
  width: 100%;
  height: 26px;
  background: linear-gradient(90deg, #4ebbf3 0%, #2487ca 100%);
  border-radius: 0px 0px 4px 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  box-sizing: border-box;
  position: fixed;
  bottom: 0;
  .custom-bottom-info {
    font-size: 12px;
    font-weight: 400;
    color: #ffffff;
  }
  .custom-bottom-operate {
    .custom-bottom-operate-icon {
      width: 18px;
      height: 14px;
      margin-right: 12px;
    }
  }
}
</style>
